import Roles from '@/auth/roles';
import UserList from './user-list';
import UserHistoryFull from './user-history/user-history-full/user-history-full';
import UserHistorySingle from './user-history/user-history-single/user-history-single';
import UserShow from './user-show';
import UserEdit from './user-edit';
import UserNew from './user-new';
import UserActivity from './user-activity';
import MainLayout from '../shared/layout/main-layout';

const roles = Roles.values;

export default [
  {
    path: '',
    component: MainLayout,
    meta: { auth: true },
    children: [
      {
        name: 'userList',
        path: 'user',
        component: UserList,
        meta: {
          auth: true,
          roles: [
            roles.owner.id,
            roles.securityReviewer.id,
            roles.activityViewer.id
          ]
        }
      },
      {
        name: 'userEdit',
        path: 'user/:id/edit',
        component: UserEdit,
        props: true,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.securityReviewer.id]
        }
      },
      {
        name: 'userNew',
        path: 'user/new',
        component: UserNew,
        props: true,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.securityReviewer.id]
        }
      },
      {
        name: 'userActivity',
        path: 'user/:id/activity',
        component: UserActivity,
        props: true,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.activityViewer.id]
        }
      },
      {
        name: 'userHistorySingle',
        path: 'user/:id/history',
        component: UserHistorySingle,
        props: true,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.activityViewer.id]
        }
      },
      {
        name: 'userHistoryFull',
        path: 'user/history',
        component: UserHistoryFull,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.activityViewer.id]
        }
      },
      {
        name: 'userShow',
        path: 'user/:id',
        component: UserShow,
        props: true,
        meta: {
          auth: true,
          roles: [roles.owner.id, roles.securityReviewer.id]
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/user/user-routes.js